import React from "react";
import { Footer } from "./components"
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Helmet from "react-helmet";
import {
  BrabantWallon,
  Bruxelles,
  Home,
  Liège,
  NotFound,
} from "./routes";
//import theme from "./utils/theme";

import "./assets/css/style.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

library.add(fab);
library.add(fas);

// eslint-disable-next-line
export default () => {
  return (
    <Router basename="/">
        <Helmet></Helmet>

        <Routes>
          <Route path="/"
            element = {<Home />} />
          <Route path="bruxelles"
            element = { <Bruxelles /> } />
          <Route path="liege"
            element = { <Liège /> } />
          <Route path="brabant-wallon"
            element = { <BrabantWallon /> } />
          <Route path="*"
            element = {<NotFound />} />
        </Routes>

        <Footer />
    </Router>
  );
};
